<template>
  <div class="layout-sub-title">
    <div class="inner">
      <h3>{{title}}</h3>
      <div>{{enTitle}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubTitle",
  props: {
    title: String,
    enTitle: String
  }
}
</script>

<style scoped>

</style>